/**
 * Expõe jQuery globalmente antes de qualquer plugin que dependa de window.jQuery (ex.: Summernote lang).
 * Deve ser o primeiro import em main.js para que rode antes dos arquivos de idioma do Summernote.
 */
import jquery from 'jquery';
window.$ = window.jQuery = jquery;
